import { HttpClient } from '../../common/HttpClient';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from './../../environments/environment';

@Injectable()
export class CommonService {
  private _optionsUrl = '';
  private options: Observable<any>;

  constructor(private _http: HttpClient) {
    this._optionsUrl = `${environment.serviceUrl}options`;
  }

  getOptions(): Observable<any> {
    return this._http
      .get(`${this._optionsUrl}`, '')
      .map(response => response.json());
  }
}
